<div fxLayout="row" class="main-wrapper" *ngIf="items.length > 0" style="margin-top:-10px">
    <form [formGroup]="enumDropdownForm" fxFlexFill fxFlex.gt-sm="100" fxFlex.xs="100">
      <mat-label class="mat-form-field-label-dropdown"> {{ "area-group-type-dropdown.title" | translate }} </mat-label>
    <ng-multiselect-dropdown
    appFocusOnClick
    [placeholder]=placeholder
    [settings]="dropdownSettings"
    [data]="items"
    [(ngModel)]="selectedItems"
    (onSelect)="onSelect($event)"
    (onSelectAll)="onSelectAll($event)"
    (onDeSelect)="onItemDeSelect($event)"
    id="selected"
    formControlName="selected"
    name="selected"
  >
  </ng-multiselect-dropdown>
  <mat-error class="dropdown-error" *ngIf="enumDropdownForm.touched && !singleSelection && enumDropdownForm.controls['selected'].errors?.['required']">
    {{ "error.required_area-group-types" | translate }}
  </mat-error>
  <mat-error class="dropdown-error" *ngIf="enumDropdownForm.touched && singleSelection && enumDropdownForm.controls['selected'].errors?.['required']">
    {{ "error.required_area-group-type" | translate }}
  </mat-error>
  </form>
  </div>

